/*
 *
 * AssignedView actions
 *
 */

import {
  EXECUTE_ADD_ACTION,
  EXECUTE_COPY_ACTION,
  EXECUTE_EDIT_ACTION,
  EXECUTE_ACCEPT_ACTION,
  EXECUTE_REJECT_ACTION,
  EXECUTE_COMPLETE_ACTION,
  EXECUTE_VIEW_ACTION,
  EXECUTE_CLOSE_ACTION,
} from './constants';

export function executeAddAction() {
  return {
    type: EXECUTE_ADD_ACTION,
  };
}

export function executeEditAction(id) {
  return {
    type: EXECUTE_EDIT_ACTION,
    payload: { id },
  };
}

export function executeCopyAction(id) {
  return {
    type: EXECUTE_COPY_ACTION,
    payload: { id },
  };
}

export function executeAcceptAction(ids) {
  return {
    type: EXECUTE_ACCEPT_ACTION,
    payload: { ids },
  };
}

export function executeRejectAction(ids) {
  return {
    type: EXECUTE_REJECT_ACTION,
    payload: { ids },
  };
}

export function executeCompleteAction(id) {
  return {
    type: EXECUTE_COMPLETE_ACTION,
    payload: { id },
  };
}

export function executeViewAction(id) {
  return {
    type: EXECUTE_VIEW_ACTION,
    payload: { id },
  };
}

export function executeCloseAction(ids) {
  return {
    type: EXECUTE_CLOSE_ACTION,
    payload: { ids },
  };
}

